// Counts a dashboard announcement visit when the card was rendered for a hover
// prefetch (see AnnouncementsHelper#dashboard_announcement). Removes itself so
// the cached page, restored on Back, doesn't post again.
export default class extends HTMLElement {
  connectedCallback () {
    const url = this.dataset.url

    this.remove()

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content }
    }).catch(() => {})
  }
}
